// src/services/calendarService.ts
import api from '../services/api';
import { EthiopianDate, MonthCalendar } from '../types/calendar';

export const getCurrentDate = async (): Promise<{ date: EthiopianDate, month_name: string, day_name: string }> => {
    const response = await api.get('/calendar/current');
    return response.data;
};

export const getMonthCalendar = async (year: number, month: number): Promise<MonthCalendar> => {
    const response = await api.get('/calendar/month', {
        params: { year, month, calendar_type: 'ethiopian' }
    });
    return response.data;
};
